import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Rx';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { StripePayment } from '../models/stripePayment';
import {ApiService} from './api.service';
import { CognitoUtil } from './cognito.service';

@Injectable()
export class PlaidService {

    plaidLink = environment.plaidLink;

    apiService: ApiService = new ApiService(this.http, this.cognito);

    constructor(
      private http: Http, private cognito: CognitoUtil
    ) { }

    postPlaid(postObject){
      return this.apiService.postCall('plaidLink' , 'plaid/item',postObject);
    }

    deletePlaid(caseId, itemId){
      return this.apiService.deleteCall('plaidLink',`case/${caseId}/plaid/${itemId}`);
    }

    postACHPlaid(postObject){
      return this.apiService.postCall('plaidLink', 'plaid/ach', postObject);
    }

    removeBankAccount(financialId, caseId) {
      return this.apiService.deleteCall('plaidLink', `case/${caseId}/plaid/${financialId}`);
    }

    getBankAccount(financialId, caseId) {
      return this.apiService.getCall('plaidLink', `case/${caseId}/plaid/${financialId}`);
    }

    putBank(caseId: string, itemId: string, data: any){
      return this.apiService.putCall('plaidLink', `case/${caseId}/plaid/${itemId}`,data);
    }

    getTransactionsByYear(year, caseId, accountId){
      return this.apiService.getCall('plaidLink', `transactions/year/${year}/case/${caseId}/${accountId}`);
    }

    deleteTransaction(caseId, itemId){
      return this.apiService.deleteCall('plaidLink', `case/${caseId}/plaid/${itemId}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/plaid.service.ts